import toast from "react-hot-toast";

/**
 * Copies a string to the clipboard and shows a success toast.
 * @param {string} text - The text to be copied to the clipboard.
 * @param {string} message - The message to be displayed in the toast notification.
 */
export const copyToClipboard = (text, message = "Copied to clipboard!") => {
  if (!text) return;

  navigator.clipboard.writeText(text)
    .then(() => {
      toast.success(message);
    })
    .catch((err) => {
      console.error('Failed to copy text: ', err);
      toast.error("Failed to copy text");
    });
};
